import React from "react";
import classes from "./style.module.scss";
import twGuessImg from "../../../assets/images/tw/tw-guess-img.png";
import guesserBg from "../../../assets/images/tw/guesser-bg.png";

const GuessCard = (props) => {
  const { image, personName, btnText, mysteryWord } = props;
  return (
    <>
      {/* <div className={classes.root}>
        <div className={classes.imageContainer}>
          <div className="text-right">
            <p className={classes.typeText}>Guess</p>
          </div>
          <img className={classes.image} src={image} alt="imageOfGuessCard" />
          <p className={classes.personName}>{personName}</p>
        </div>
        <div className={classes.btnContainer}>
          <button type="button" className="guess_bubbl">
            {btnText}
          </button>
        </div>
      </div> */}
      <div className="tw-final-word-guess">
        <div className="tw-final-word-flex">
          <div className="guesser">
            <img src={image} alt="imageOfGuessCard" />
          </div>
          {/* <div className="guesser-word-name">
            <img src={twGuessImg} className="guesser-word-img" alt="sff" />
            <div className="guesser-word">{btnText}</div>
          </div> */}
          <div className="guesser-word2">
            <img src={guesserBg} className="guesser-bg" alt="f" />
            <p className="mb-0 txt">{btnText}</p>
          </div>
        </div>
        <p className="guesser-name">{personName}</p>
      </div>
    </>
  );
};

export default GuessCard;
